module.exports = __webpack_public_path__ + "static/title1.209ef1e6c65fa90e389fd52356977e92.png";